import { render, staticRenderFns } from "./unSignBank.vue?vue&type=template&id=63870cd6"
import script from "./unSignBank.vue?vue&type=script&lang=js"
export * from "./unSignBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports